module.exports = __webpack_public_path__ + "static/media/splash-bg.89fab040.jpg";